export default __webpack_public_path__ + "static/media/37.e6c9b74b.jpeg";